import chalk from 'chalk';

const logger = {
  error(...args: any[]) {
    console.log(chalk.red(...args));
  },
  warn(...args: any[]) {
    console.log(chalk.yellow(...args));
  },
  info(...args: any[]) {
    console.log(chalk.cyan(...args));
  },
  success(...args: any[]) {
    console.log(chalk.green(...args));
  },
  break() {
    console.log('');
  },
};

export default logger;
